import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, NgClass, AsyncPipe } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { orgaExamples } from '../../../assets/ressources/orga-examples';
import { companies } from '../../../assets/ressources/companies';
import { AppService, ColorService, SEOService } from '../../services';
import { ContactInfo } from '../../models';
import { HelpStore } from '../../stores';
import { TranslocoModule } from '@ngneat/transloco';
import { HelpDirective } from '../../shared/directives/help.directive';
import { MatAnchor } from '@angular/material/button';
import { AllOrganizersCarouselComponent } from '../../shared/components/all-organizers-carousel/all-organizers-carousel.component';
import { LetDirective } from '../../shared/directives/let.directive';
import { MatTooltip } from '@angular/material/tooltip';
import { MatCard } from '@angular/material/card';
import { NewsletterFormComponent } from '../components/newsletter-form/newsletter-form.component';
import { ContactFormComponent } from '../../shared/components/contact-form/contact-form.component';
import { SafePipe } from '../../pipes/safe.pipe';
import { ROUTES } from '../../routes.constants';

@Component({
  selector: 'app-home-orga',
  templateUrl: './home-orga.component.html',
  styleUrls: ['./home-orga.component.scss'],
  standalone: true,
  imports: [
    TranslocoModule,
    HelpDirective,
    MatAnchor,
    RouterLink,
    AllOrganizersCarouselComponent,
    LetDirective,
    NgClass,
    MatTooltip,
    MatCard,
    NewsletterFormComponent,
    ContactFormComponent,
    AsyncPipe,
    SafePipe,
  ],
})
export class HomeOrgaComponent implements AfterViewInit, OnDestroy, OnInit {
  appService = inject(AppService);
  colorService = inject(ColorService);
  private route = inject(ActivatedRoute);
  private seoService = inject(SEOService);
  private helpStore = inject(HelpStore);
  private platformId = inject(PLATFORM_ID);

  ROUTES = ROUTES;
  fragment: string;
  orgaExamples: Array<{imgsUrl: {desktop: string, mobile: string}, name: string, color: string}> = orgaExamples;
  /* TODO set organizers feedbacks when they will be available
  feedbacks: Array<{event: string, gender: gender, name: string, quote: string}> = feedbacks;
  */
  companies = companies;
  @ViewChild('partners') public partners: ElementRef;
  selectedEventIndex: number;
  dashboardTab = [
    {url: 'Dashboard-Mes-événements-2024.png', clickable: true},
    {url: 'Dashboard-Activité-2024.png', clickable: true},
    {url: '', clickable: false}, // Event Name
    {url: 'Dashboard-Données-2024.png', clickable: true},
    {url: 'Dashboard-Tarifs-2024.png', clickable: true},
    {url: 'Dashboard-Participants-2024.png', clickable: true},
    {url: 'Dashboard-Liste-d-attente-2024.png', clickable: true},
    {url: 'Dashboard-Infos-2024.png', clickable: true},
    {url: 'Dashboard-Ressources-2024.png', clickable: true},
  ];
  selectedDashboardIndex = 0;

  private isBrowser = false;

  constructor() {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    // SEO
    const translations = this.route.snapshot.data?.SEOTranslations ?
      this.route.snapshot.data?.SEOTranslations : this.seoService.defaultSEOTranslations;
    this.seoService.updateTitle(translations.title);
    this.seoService.updateDescription(translations.description);
    // init current element
    const currentDate = new Date();
    this.selectedEventIndex = currentDate.getTime() % this.orgaExamples.length;
    this.setEvent();

    this.helpStore.loadContactInfo(new ContactInfo({subject: 'Organisateur'}));
  }

  ngAfterViewInit() {
    this.setEvent();
    this.fragment = this.route.snapshot.fragment;
    if (this.fragment && this.fragment.indexOf('partenaire') > -1 && this.isBrowser) {
      setTimeout(() => {
        if (this.partners?.nativeElement) {
          // new elements may have been loaded above so we adjust scroll
          this.scrollToElement(this.partners.nativeElement);
        }
      }, 250);
    }
  }

  ngOnDestroy() {
    this.colorService?.resetEventColor();
  }

  setEvent() {
    this.setEventColor(this.orgaExamples[this.selectedEventIndex].color);
  }

  changeEvent() {
    this.selectedEventIndex = (this.selectedEventIndex + 1) % orgaExamples.length;
    this.setEvent();
  }

  setEventColor(color: string) {
    if (color) {
      this.colorService.setEventColor({color});
    }
  }

  scrollToElement(el: HTMLElement) {
    if (el && isPlatformBrowser(this.platformId)) {
      el.scrollIntoView({behavior: 'smooth'});
    }
  }

}
